import React from "react";
import { IItemData } from "./common.typing";
import Tag from "./Tag";

import locale, { isEN } from "../../_util/locale";
import PrincipalTag from "./assets/tag/principal";
import { GroupCate, DEFAULT_USER_IMG } from "./utils";

export interface ICommonItemProps {
    type?: string;
    pikerType?: string;
    isShowOrg?: boolean;
    item: IItemData;
    isShowGroupMemberRole?: boolean;
    isSearchHighlight?: boolean;
}

const CommonItem: React.FC<ICommonItemProps> = ({
    type,
    pikerType,
    isShowOrg = true,
    item,
    isShowGroupMemberRole = true,
    isSearchHighlight = false,
}) => {
    const getName = (item: IItemData): string => {
        const { i18n_name, name } = item;
        const { en_us, zh_cn } = i18n_name || {};
        return (isEN() ? en_us : zh_cn) || name;
    };

    // 生成名称
    const genCommonName = () => {
        // 搜索高亮特殊处理
        if (isSearchHighlight) {
            return (
                <span
                    className="commonName"
                    dangerouslySetInnerHTML={{ __html: item.showName }}
                />
            );
        }
        return (
            <span className="commonName">
                {getName(item)}
                {getName(item) !== item.name_nick && item.name_nick
                    ? `(${item.name_nick})`
                    : ""}
            </span>
        );
    };

    // 生成部门
    const genCommonOrg = () => {
        if (isSearchHighlight) {
            return (
                <span
                    className="userOrg"
                    dangerouslySetInnerHTML={{
                        __html: item.deptDesc || item.dept,
                    }}
                />
            );
        }
        if (isShowOrg) {
            const _deptName =
                item.deptDesc || item.dept_name || item.dept || item.cp_name;
            return <span className="userOrg">{_deptName}</span>;
        }
        return null;
    };

    // 高亮时群组描述
    const genCommonGroup = () => {
        if (isSearchHighlight) {
            return (
                <span
                    className="userOrg"
                    style={{
                        minWidth: `${
                            type === "group" || item.type == "team"
                                ? "195px"
                                : "240px"
                        }`,
                    }}
                    dangerouslySetInnerHTML={{
                        __html: item.groupDesc,
                    }}
                />
            );
        }
        return null;
    };

    /**
     * 生成群组角色
     * @param item
     * @returns
     */
    const genGroupMemberRole = (item: IItemData) => {
        return (
            <>
                {item.role == 0 && (
                    <span className="owner">{locale("common_manager1")}</span>
                )}
                {item.role == 1 && (
                    <span className="owner">{locale("common_manager2")}</span>
                )}
            </>
        );
    };

    const isShowCommonOrg =
        type === "member" || type === "contact" || type === "combination";

    const isShowCommonGroup = type === "group";

    const isShowGroupCount =
        !isSearchHighlight && // 搜群群高亮不能展示群人数
        (type == "combination" ||
            (type === "group" && pikerType === "member")) && // 群列表，且组件类型是选人，需要展示群人数
        (item.type == "team" || item.id?.toString().includes("-team-")); // 保证是群

    return (
        <div
            className={`${
                type === "group" || item.type == "team"
                    ? "commonItemShort"
                    : "commonItem"
            }`}
        >
            {type !== "partner" && (
                <img
                    className="commonPic 111"
                    src={`${
                        item.pic || DEFAULT_USER_IMG
                    }?imageMogr2/auto-orient|imageView2/1/w/80/h/80|imageMogr2/ignore-error/1`}
                />
            )}
            <div className="commonNameContent">
                <div className="commonNameBox">
                    {genCommonName()}
                    {item?.isManager && <PrincipalTag></PrincipalTag>}
                    <Tag
                        isExternal={
                            item.external_tag === 1 ||
                            item.external_flag === 1 ||
                            item.external_flag === 2 ||
                            type === "contact"
                        }
                        isSquad={
                            item?.isSquad ||
                            item?.group_cate === GroupCate.squad
                        }
                        type={item?.is_robot ? 202 : item.source}
                        tagImgName={item.tpl_type_icon}
                        tagImgEnName={item.tpl_type_icon_en}
                        groupTags={item.groupTags || item.group_tags}
                    />
                    {type === "member" &&
                        isShowGroupMemberRole &&
                        genGroupMemberRole(item)}
                </div>

                {isShowCommonOrg && genCommonOrg()}
                {isShowCommonGroup && genCommonGroup()}
                {isShowGroupCount && (
                    <span className="commonCount">
                        {item.group_users_count || item.group_user_count || 0}
                        {locale("common_persion")}
                    </span>
                )}
            </div>
        </div>
    );
};

export default CommonItem;
